/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'confluence-table-tree.column.contributors': 'Bidragsytere',
  'confluence-table-tree.column.last-modified': 'Sist endret',
  'confluence-table-tree.column.title': 'Navn',
  'confluence-table-tree.could-not-load': 'Kan ikke laste inn',
  'confluence-table-tree.could-not-load-contributors': 'Kan ikke laste inn bidragsytere',
  'confluence-table-tree.create-child-page': 'Opprett en underordnet side',
  'confluence-table-tree.create-page': 'Opprett side',
  'confluence-table-tree.default.page.title': 'Uten navn',
  'confluence-table-tree.default.show-all-pages-button.label': 'Vis flere sider',
  'confluence-table-tree.draft.lozenge': 'UTKAST',
  'confluence-table-tree.draft.tooltip': 'Utkast kan kun ses av deg.',
  'confluence-table-tree.drafts-toggle.label': 'Vis utkast',
  'confluence-table-tree.edit': 'Rediger',
  'confluence-table-tree.edit-in-confluence': 'Rediger i Confluence',
  'confluence-table-tree.empty.description':
    'Opprett møtenotater, produktkrav, beslutninger eller annet innhold for å fylle opp dette området.',
  'confluence-table-tree.empty.title': 'Her finnes det ingenting annet enn potensial',
  'confluence-table-tree.error.description': 'Vi kan ikke vise deg disse sidene. Prøv igjen senere.',
  'confluence-table-tree.error.row': 'Kan ikke laste inn sider.',
  'confluence-table-tree.error.title': 'Vel, dette er pinlig …',
  'confluence-table-tree.friendly-when-created': 'Opprettet',
  'confluence-table-tree.friendly-when-updated': 'Oppdatert',
  'confluence-table-tree.share.copied': 'Kopiert til utklippstavlen',
  'confluence-table-tree.share.copy-button': 'Kopier',
  'confluence-table-tree.share.subtitle': 'Del denne koblingen',
  'confluence-table-tree.share.title': 'Del side',
  'confluence-table-tree.share.tooltip': 'Del',
  'confluence-table-tree.view-profile': 'Se profil',
};
